var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgM28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 112.75 36.34"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 106.92,
  height: 35.34,
  x: 0.5,
  y: 0.5,
  rx: 3.41,
  style: {
    fill: "#fff"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M109.14 34h-.64v-.39h1.73V34h-.63v1.72h-.46ZM110.48 33.57h.65l.5 1.45.47-1.45h.65v2.11h-.43v-1.5l-.51 1.5h-.36l-.52-1.48v1.48h-.43Z",
  "data-tm": "true"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.72 7.14h12.43l3.66 13h.06l3.66-13H39v22.34h-8v-16h-.07l-4.69 16h-6.7l-4.69-16h-.06v16h-8Z",
  style: {
    fill: "#db011c"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M62 15.56a2.31 2.31 0 0 0 2.07-1.73c.29-1.27-1.18-1.78-3.25-1.78-2.43 0-4.92.22-5.78 3.09h-9.53C47.81 7.52 55.31 6.5 61 6.5c7.23 0 13.8 1.27 12.49 7.5-.89 4.21-5.61 5.91-8.93 6.51L56.23 22c-2 .35-3.09.86-3.83 1.69h18.54l-1.18 5.55h-28c2-8.51 7.91-11.1 13.46-12.25ZM101.7 12.72a5.74 5.74 0 0 1-5 4.56v.06a4 4 0 0 1 3.64 5.05c-1.09 5.16-6 7.4-15.76 7.4S71 27.55 72.06 22.39a6.77 6.77 0 0 1 5.74-5.05v-.06c-2.36-.41-3.51-2-3-4.56 1.06-5 6.73-6.22 14.77-6.22s13.18 1.18 12.13 6.22m-20.23 9.63c-.26 1.18.54 2.08 4.34 2.08s5-.9 5.23-2.08c.38-1.78-.77-2.29-4.31-2.26s-4.88.48-5.26 2.26m10.85-8.71c.28-1.37-.71-1.78-3.86-1.78s-4.34.41-4.63 1.78.67 1.86 3.83 1.86 4.34-.42 4.66-1.86"
})));
export default SvgM28;